import React from 'react';

const DOM_Forms = () => {
  return (
    <div >
      <h1>DOM_Forms</h1>
      <p>Placeholder component for: "DOM Forms"</p>
    </div>
  );
};

export default DOM_Forms;
